import createPersistedState from '~/react-hooks/use-persisted-state';
const optimisedSendingHook = createPersistedState('optimised-sending');

export interface OptimisedSendingHookProps {
  value: boolean;
  setValue: (value: boolean) => void;
}

export function useOptimisedSending(defaultValue: boolean = false) {
  const [value, setValue] = optimisedSendingHook<boolean>(defaultValue);

  return {
    value,
    setValue,
  } as OptimisedSendingHookProps;
}
